<template>
	<div class="display-flex flex-wrap">
		<div class="flex-col-12 form-section">
			<InfoSection class="py-4 px-3 mt-4">
				<div class="text-center">
					<h3>
						In order to change sample data for this feature,<br />Run the following command:
						<AppTextField
							style="z-index: 2"
							readonly
							:value="`/ply SAMPLE ${workflow.workflow_title}`"
							class="param_field"
							color="primary"
							outlined
							single-line
							@focus="$event.target.select()"
						/>
						in Slack
					</h3>
				</div>
			</InfoSection>
		</div>
		<div class="flex-1 flex-center--end actions-section"></div>
	</div>
</template>

<script>
export default {
	name: 'SlackToolPlacementEditor',
	props: { workflow: { type: Object }, loading: { type: Boolean } },
	components: {},
	computed: {},
	methods: {},
	data() {
		return {};
	},
	beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.form-section {
	z-index: $z-index-2;
}
.actions-section {
	z-index: $z-index-1;
}
</style>
